import { TopicDetached } from '../graphql/generated/graphql';
import { isFeatureEnabled } from '../utils/features';

const isNotDetached = (topic: { detached: TopicDetached }) =>
  !isFeatureEnabled('detached_topics') || topic.detached === TopicDetached.None;

export default isNotDetached;
